module.exports = {
  title: 'Rich Text',
  context: {
    heading: 'Lorem Ipsum',
    text: '<p>Praesent tempor blandit tempus. Pellentesque ac arcu ligula. Nullam cursus.</p><p>An example <a href="#">inline link</a>.</p><ul><li>This is a list item</li><li>This is a list item</li><li>This is a list item</li></ul>',
  },
}